import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useNavigate } from "@tanstack/react-router";
import { ArrowRightLeft, Check, Download, Search } from "lucide-react";
import React from "react";
import { RECENT_MOVEMENT_ITEMS } from "../-data/inventory-data";

const OverviewList: React.FC = () => {
    const navigate = useNavigate();

    const handleRowClick = (itemId: string) => {
        navigate({ to: `/manager/inventory/${itemId}` });
    };

    const getAvailabilityBadge = (availability: string) => {
        switch (availability) {
            case "In Stock":
                return <Badge className="bg-green-600 hover:bg-green-700 text-white">{availability}</Badge>;
            case "Low Stock":
                return <Badge className="bg-orange-500 hover:bg-orange-600 text-white">{availability}</Badge>;
            case "Critical":
                return <Badge className="bg-red-600 hover:bg-red-700 text-white">{availability}</Badge>;
            case "Out of Stock":
                return <Badge variant="secondary">{availability}</Badge>;
            default:
                return <Badge variant="outline">{availability}</Badge>;
        }
    };
    return (
        <div className="w-full mt-4">
            <div className="flex flex-row items-center justify-between mb-4">
                <span className="text-xl font-medium">Recent Movement</span>
                <div className="flex flex-row items-center justify-end gap-x-2">
                    <Input 
                            placeholder="Search items..."
                            className="w-[280px]"
                            prefixIcon={<Search className="w-5 h-5 text-gray-400" />}
                        />
                    <Button variant="outline" className="rounded-[12px]"><Download className="h-5 w-5" /></Button>
                    <Button variant="outline"  className="flex flex-row items-center justify-center px-6 rounded-[12px]"><ArrowRightLeft className="mr-2"/>Sort</Button>
                </div>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className="text-black text-start">Item Name</TableHead>
                        <TableHead className="text-black text-center">SKU</TableHead>
                        <TableHead className="text-black text-center">Availability</TableHead>
                        <TableHead className="text-black text-center">Quantity</TableHead>
                        <TableHead className="text-black text-center">Reorder level</TableHead>
                        <TableHead className="text-black text-end">Actions</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {RECENT_MOVEMENT_ITEMS.map((item) => (
                        <TableRow 
                            key={item.id} 
                            className="cursor-pointer hover:bg-gray-50"
                            onClick={() => handleRowClick(item.id)}
                        >
                            <TableCell className="text-start">
                                <div className="flex flex-col">
                                    <span className="font-medium">{item.itemName}</span>
                                    <span className="text-sm text-gray-500">{item.category}</span>
                                </div>
                            </TableCell>
                            <TableCell className="text-center">{item.sku}</TableCell>
                            <TableCell className="text-center">
                                {getAvailabilityBadge(item.availability)}
                            </TableCell>
                            <TableCell className="text-center font-medium">{item.quantity}</TableCell>
                            <TableCell className="text-center">{item.reorderLevel}</TableCell>
                            <TableCell className="text-end">
                                <Button 
                                    variant="ghost" 
                                    size="sm" 
                                    className="gap-x-2"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        // Handle reorder action
                                    }}
                                >
                                    <Check className="h-4 w-4" />
                                    Reorder
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}

export default OverviewList